const Styles = {
  searchContainer: {
    mt: 3,
    mb: 3,
  },
  searchView: {
    display: 'flex',
    flexWrap: 'wrap',
    mt: 5,
    px: 6,
  },
  inputView: {
    width: 300,
  },
  searchBtnView: {
    display: 'flex',
    flexDirection: 'row',
    px: 5,
    mb: 3,
    mt: 0,
    justifyContent: 'right',
  },
  resetBtn: {
    mr: 2,
  },
  modalStyle: {
    marginTop: 50,
  },
  modalBodyContainer: {
    px: 2,
    pt: 3,
    pb: 3,
    display: 'flex',
    flexWrap: 'wrap',
  },
  infoLabelView: {
    display: 'flex',
    pr: 2,
    mb: 1,
  },
  infoLeftView: {
    mr: 10,
  },
  editBtn: {
    mr: 2,
  },
  submitBtn: {
    mb: 4,
    mt: 4,
  },
  addCrmModalBodyContainer: {
    display: 'flex',
    flexDirection: 'column',
    px: 4,
    pt: 3,
  },
  addCrmDropdown: {
    width: '100%',
  },
  midBtn: {
    justifyContent: 'flex-start',
    textAlign: 'left',
    p: 0,
  },
  addIcon: {
    fontSize: 'small',
    mr: 0.5,
  },
  addCrmWaringView: {
    display: 'flex',
    flexDirection: 'column',
    px: 4,
    pt: 3,
    mb: 2,
    alignItems: 'center',
    textAlign: 'center',
  },
};

export default Styles;
